import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ClockArrowIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M8.6665 2C5.35317 2 2.6665 4.68667 2.6665 8H0.666504L3.25984 10.5933L3.3065 10.6867L5.99984 8H3.99984C3.99984 5.42 6.0865 3.33333 8.6665 3.33333C11.2465 3.33333 13.3332 5.42 13.3332 8C13.3332 10.58 11.2465 12.6667 8.6665 12.6667C7.37984 12.6667 6.21317 12.14 5.37317 11.2933L4.4265 12.24C5.51317 13.3267 7.0065 14 8.6665 14C11.9798 14 14.6665 11.3133 14.6665 8C14.6665 4.68667 11.9798 2 8.6665 2ZM7.99984 5.33333V8.66667L10.8532 10.36L11.3332 9.55333L8.99984 8.16667V5.33333H7.99984Z" />
  </Icon>
);

export default memo(ClockArrowIcon);
